import React from 'react';
import Chart from 'react-apexcharts';
import LoaderImg from '../assets/img/logo.png';

const Loader = () => {
  return (
    // <div className="loader-main">
    //   <div className="loader">
    //     <img src={LoaderImg} className="LoaderImg" />
    //     <span></span>
    //   </div>
    // </div>

    <div className="loader-main">
      <div className="loader">
        <img src={LoaderImg} className="LoaderImg" alt="logo" />
        <span></span>
        <i className="ring ring1"></i>
        <i className="ring ring2"></i>
      </div>
    </div>
  );
};

export default Loader;
